import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import HeaderComponent from "../../helper/Navigationhelper";
import Cartlist from "../layouts/Cartlist";
import Search from "../layouts/Search";
import classNames from "classnames";
import { connect, useSelector } from "react-redux";
import Aboutus from "../sections/home/Aboutus";
import { IoBicycleOutline } from "react-icons/io5";
import { MdRestaurantMenu } from "react-icons/md";
import { getRestaurant } from "../../utils/commons";

const IconCart = () => {
	const basket = useSelector((state) => state.basket);

	return basket.mode == "delivery" ? (
		<IoBicycleOutline />
	) : basket.mode == "takeAway" ? (
		<i className="flaticon-shopping-bag" />
	) : (
		<MdRestaurantMenu />
	);
};
class Headerinner extends HeaderComponent {
	render() {
		const restaurant = getRestaurant();
		return (
			<Fragment>
				{/* Informations Start */}
				<div className="cart-sidebar-wrapper">
					<aside
						className={classNames("cart-sidebar", {
							"cart-open": this.state.infomethod,
						})}
					>
						<div className="cart-sidebar-header">
							<h3>Informations</h3>
							<div
								className="close-btn cart-trigger close-dark"
								onClick={() =>
									this.infoToggle({
										lat: parseFloat(restaurant.latitude),
										lng: parseFloat(restaurant.longitude),
									})
								}
							>
								<span />
								<span />
							</div>
						</div>
						<Aboutus />
					</aside>
					<div
						className="cart-sidebar-overlay cart-trigger"
						onClick={() =>
							this.infoToggle({
								lat: parseFloat(restaurant.latitude),
								lng: parseFloat(restaurant.longitude),
							})
						}
					/>
				</div>
				{/* Informations End */}
				{/* Cart Sidebar Start */}
				<div className="cart-sidebar-wrapper">
					<aside
						className={classNames("cart-sidebar", {
							"cart-open": this.state.cartmethod,
						})}
					>
						<div className="cart-sidebar-header">
							<h3>Mon Panier</h3>
							<div
								className="close-btn cart-trigger close-dark"
								onClick={this.cartToggle}
							>
								<span />
								<span />
							</div>
						</div>
						<Cartlist closeCartList={() => this.cartToggle(null, 1)} />
					</aside>
					<div
						className="cart-sidebar-overlay cart-trigger"
						onClick={this.cartToggle}
					/>
				</div>
				{/* Cart Sidebar End */}
				{/* Search Form Start*/}
				<div
					className={classNames("search-form-wrapper", {
						open: this.state.searchmethod,
					})}
				>
					<div className="search-trigger close-btn" onClick={this.searchToggle}>
						<span />
						<span />
					</div>
					<Search />
				</div>
				{/* Search Form End*/}
				{/* Aside (Mobile Navigation) */}
				{/* <aside
					className={classNames("main-aside", { open: this.state.navmethod })}
				>
					<Mobilemenu />
				</aside> */}
				<div className="aside-overlay aside-trigger" onClick={this.toggleNav} />
				{/* Header Start */}
				<header className="main-header header-1 header-absolute header-light">
					<div className="top-header">
						<div className="container">
							<div className="top-header-inner">
								<div className="top-header-contacts">
									<ul className="top-header-nav">
										<li>
											<a className="p-0" href={"tel:" + restaurant.landline}>
												<i className="fas fa-phone mr-2" />{" "}
												{restaurant.landline}
											</a>
										</li>
									</ul>
								</div>

								<ul className="top-header-nav header-cta">
									<li
										onClick={() =>
											this.infoToggle({
												lat: parseFloat(restaurant.latitude),
												lng: parseFloat(restaurant.longitude),
											})
										}
									>
										{" "}
										<Link to="#" className="bg-transparent">
											<i className="fas fa-info-circle mr-1  header-link-icon" />
											<span className="header-link-text">Informations</span>
										</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/">
											<i className="fas fa-home mr-1 header-link-icon" />
											<span className="header-link-text">
												Commandez en ligne
											</span>
										</Link>{" "}
									</li>
									<li className="cart-trigger" onClick={this.cartToggle}>
										{this.props.basket.items.length > 0 && (
											<span className="cart-item-count">
												{this.props.basket.items.length}
											</span>
										)}
										<IconCart />
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="container">
						{/* <nav className="navbar"> */}
						{/* Logo */}
						{/* <Link className="navbar-brand" to="/"> */}{" "}
						{/* <img src={process.env.PUBLIC_URL + '/assets/img/logo-light.png'} alt='logo' />{' '} */}
						{/* <img
									src={process.env.REACT_APP_PUBLIC_URL + application.logo}
									style={{ width: "60%", resizeMode: "container" }}
								/>
							</Link> */}
						{/* Menu */}
						{/* <Menu /> */}
						{/* <div className="header-controls">
								<ul className="header-controls-inner">
									<li
										className="cart-dropdown-wrapper cart-trigger"
										onClick={this.cartToggle}
									>
										{this.props.basket.items.length > 0 && (
											<span className="cart-item-count">
												{this.props.basket.items.length}
											</span>
										)}
										<i className="flaticon-shopping-bag" />
									</li> */}
						{/* <li
										className="search-dropdown-wrapper search-trigger"
										onClick={this.searchToggle}
									>
										<i className="flaticon-search" />
									</li> */}
						{/* </ul> */}
						{/* Toggler */}
						{/* <div
									className="aside-toggler aside-trigger"
									onClick={this.toggleNav}
								>
									<span />
									<span />
									<span />
								</div> */}
						{/* </div>
						</nav> */}
					</div>
				</header>
				{/* Header End */}
			</Fragment>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		basket: state.basket,
	};
};

export default connect(mapStateToProps)(Headerinner);
